import { useWindowDimensions } from "../../utils/utils";
import Banner from "../../components/layout/banner";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  WhatsApp,
  CallSharp,
  ChevronLeft,
  ChevronRight,
  Close,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { RootState } from "../../app/store";
import { formatMoney } from "../../utils/format";
import Button from "../../components/form/button";
import Modal from "../../components/common/modal";
import Transaction from "../../components/ux/transaction";
import Validation from "../../components/ux/order-validation";
import {
  dismissValidationModal,
  toggleTransactionModal,
  dismissTransactionModal,
  toggleValidationModal,
} from "../../features/payments/paymentsSlice";
import { useQuery } from "@apollo/client";
import { PRODUCT, PRODUCTS_BY_IDS } from "../../api/product/queries";
import { CommentSection } from "./comment";
import {
  dismissUpSalesModal,
  toggleUpSalesModal,
} from "../../features/products/productsSlice";
import Header from "../../components/layout/header";
import UpSell from "../../components/ux/upsell";
import FloatingButton from "../../components/common/floating-button";
import LazyMultilingualAudioPlayer from "../../components/common/lazy-multilingual-audio-player";
import audioTrackWo from "../../assets/tracks/disaar-wo.m4a";

interface Props {}

// Helper function to calculate the selling price based on quantity
const getSellingPrice = (basePrice, quantity, priceForTwo, priceForThree) => {
  switch (quantity) {
    case 1:
      return basePrice;
    case 2:
      return priceForTwo;
    case 3:
      return priceForThree;
    default:
      // For quantities greater than 3, apply a general discount or calculate based on base price
      // This logic assumes a 1000 FCFA discount per unit for quantities > 3
      return basePrice * quantity - 1000 * quantity;
  }
};

function DISAAR(props: Props) {
  const dispatch = useAppDispatch();
  const { productId } = useParams(); // Keep useParams if you intend to use dynamic product IDs
  const { data, loading, error } = useQuery(PRODUCT, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      productId: "66841b202d2d08dfc58d733d", // Ensure this matches the DISAAR product ID
    },
  });

  const { width } = useWindowDimensions();
  const [state, setState] = useState({
    loaded: false,
    quantity: 1,
    lineClamp: false, // Set to false to make it open by default
    showMoreOrLess: "Voir Moins", // Set to "Voir Moins" to match open state
    product: {
      _id: "66841b202d2d08dfc58d733d",
      shop: {
        _id: "63d12a74fe7b1e352d970f18",
      },
      name: "DISAAR SERUM",
      price: 3500,
      previousPrice: 5000,
      price_for_two: 6000,
      price_for_three: 7500,
      selling_for: 3500, // Initial selling price for quantity 1
      uri: "https://vertus-organic.web.app/disaar",
    },
  });

  const slideIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isValidationModalOpen = useAppSelector(
    (state: RootState) => state.payments.isValidationModalOpen
  );

  const isTransactionModalOpen = useAppSelector(
    (state: RootState) => state.payments.isTransactionModalOpen
  );

  const upSalesModalIsOpen = useAppSelector(
    (state: RootState) => state.products.product.upSalesModalIsOpen
  );

  const {
    data: products,
    fetchMore,
    networkStatus,
    refetch,
  } = useQuery(PRODUCTS_BY_IDS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      first: 50, // Using a fixed value as 'first' was not dynamic
      productIds: [
        "66841adb2d2d08dfc58d7338",
        "66841bab2d2d08dfc58d7342",
        "68a892a9ab7b543b43832558",
        "69e9f8be825caf554441d20e", // Other relevant product (example)
      ],
    },
  });

  const images = [
    "https://newhackerway.blob.core.windows.net/images/Disaar/2.png?sp=r&st=2025-07-08T14:15:57Z&se=2029-07-08T22:15:57Z&sv=2024-11-04&sr=b&sig=XWL%2FO%2BIBnZCYrE3fmzpq4U80r3phlnS1ha%2B0Mb8u1TI%3D",
    "https://newhackerway.blob.core.windows.net/images/Minoxidil/01.png?sp=r&st=2026-01-29T01:42:07Z&se=2029-01-29T09:57:07Z&sv=2024-11-04&sr=b&sig=djxCk%2BSiBOeDRBnYbyB6aLjzXaWmEMHV3KeKVTCuxFQ%3D",
    "https://newhackerway.blob.core.windows.net/images/Disaar/09.png?sp=r&st=2026-01-29T01:57:14Z&se=2029-01-29T10:12:14Z&sv=2024-11-04&sr=b&sig=uetSo11uSO4mZMeOgm%2FyM%2BmoGx%2FXRb4XAfKZgNYlTQY%3D",
    "https://newhackerway.blob.core.windows.net/images/Disaar/7.png?sp=r&st=2025-07-08T14:20:44Z&se=2029-07-08T22:20:44Z&sv=2024-11-04&sr=b&sig=mZdZqYZIPiZEgQaZqhPxp1IzF2YeYUM3ZL7qJkOY%2FAo%3D",
    "https://newhackerway.blob.core.windows.net/images/Minoxidil/04.png?sp=r&st=2026-01-29T01:45:35Z&se=2029-01-29T10:00:35Z&sv=2024-11-04&sr=b&sig=AImFSRPZa2XqwW3Kk4R4ailqLv%2FFFIQVJOipPCGAtRo%3D",
    "https://newhackerway.blob.core.windows.net/images/Disaar/18.png?sp=r&st=2025-07-08T14:48:29Z&se=2029-07-08T22:48:29Z&sv=2024-11-04&sr=b&sig=ilUoo74Esg2wjYXXEqL0csKJs06VsA3duLHzo%2FyWt8A%3D",
    "https://newhackerway.blob.core.windows.net/images/Minoxidil/02.png?sp=r&st=2026-01-29T01:46:16Z&se=2029-01-29T10:01:16Z&sv=2024-11-04&sr=b&sig=at8m35e0dmMcOBNV6pOsyaq62nyHjHoqoMAM1EIq7v8%3D",
    "https://newhackerway.blob.core.windows.net/images/Disaar/1.png?sp=r&st=2025-07-08T14:19:07Z&se=2029-07-08T22:19:07Z&sv=2024-11-04&sr=b&sig=AeHNAfS6qNTz%2BqmMCpfu%2FcuwZzxfSfDvnHkLuqrRmuE%3D",
    "https://newhackerway.blob.core.windows.net/images/Minoxidil/06.png?sp=r&st=2026-03-15T17:07:05Z&se=2029-03-16T01:22:05Z&sv=2024-11-04&sr=b&sig=QXacXls1Xc07bxy1XHmjqGaXANOgPU7YmPfM52tiCFw%3D",
    "https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/84.png?sp=r&st=2025-07-08T14:09:43Z&se=2029-07-08T22:09:43Z&sv=2024-11-04&sr=b&sig=2pin4dMuKeqynhDhCh7eqU4cdmXMfpINdi0xo7xMGNY%3D",
    "https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/69.png?sp=r&st=2025-07-08T14:08:12Z&se=2029-07-08T22:08:12Z&sv=2024-11-04&sr=b&sig=mZI%2Fm9lL6LMr%2BOZ1CtmWRk7GHq9IeKv1qhDk%2BEGfBEQ%3D",
    "https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/83.png?sp=r&st=2025-07-08T14:10:43Z&se=2029-07-08T22:10:43Z&sv=2024-11-04&sr=b&sig=k%2FVU5KmFI%2FP3ceI%2FeB77hJXOT4pNi%2BQ6Jim%2BUDec9RM%3D",
  ];

  // Centralized function to update quantity and selling price
  const updateQuantityAndPrice = (newQuantity) => {
    setState((prevState) => {
      // Ensure quantity doesn't go below 1
      const effectiveQuantity = Math.max(1, newQuantity);

      const newSellingFor = getSellingPrice(
        prevState.product.price,
        effectiveQuantity,
        prevState.product.price_for_two,
        prevState.product.price_for_three
      );

      return {
        ...prevState,
        quantity: effectiveQuantity,
        product: {
          ...prevState.product,
          selling_for: newSellingFor,
        },
      };
    });
  };

  const handleSetQuantity = (quantity) => {
    updateQuantityAndPrice(quantity);
  };

  const handleDecreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity - 1);
  };

  const handleIncreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity + 1);
  };

  const handleSubmit = (e: any) => {
    dispatch(toggleValidationModal());
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const slideRef = useRef<HTMLDivElement>(null);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  const handleChevronLeft = useCallback(() => {
    const size = images?.length;
    setCurrentIndex((prevIndex) => (prevIndex + size - 1) % size);
  }, [images?.length]);
  const handleChevronRight = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
  }, [images?.length]);
  const pauseSlider = useCallback(() => {
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
  }, []);
  const startSlider = useCallback(() => {
    pauseSlider();
    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
    }, 5000);
  }, [images?.length, pauseSlider]);
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);
  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);
  const handleTouchEnd = useCallback(() => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        handleChevronRight();
      } else {
        handleChevronLeft();
      }
    }
  }, [handleChevronLeft, handleChevronRight]);
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handleChevronLeft();
      } else if (e.key === "ArrowRight") {
        handleChevronRight();
      } else if (e.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    },
    [handleChevronLeft, handleChevronRight, isFullscreen]
  );

  useEffect(() => {
    startSlider();
    if (slideRef.current) {
      slideRef.current.addEventListener("mouseenter", pauseSlider);
      slideRef.current.addEventListener("mouseleave", startSlider);
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      pauseSlider();
      if (slideRef.current) {
        slideRef.current.removeEventListener("mouseenter", pauseSlider);
        slideRef.current.removeEventListener("mouseleave", startSlider);
      }
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [startSlider, pauseSlider, handleKeyDown]);

  const toggleLineClamp = () => {
    setState((prevState) => ({
      ...prevState,
      lineClamp: !prevState.lineClamp,
      // Corrected logic: if lineClamp is now TRUE (clamped), show "Voir Plus".
      // If lineClamp is now FALSE (not clamped), show "Voir Moins".
      showMoreOrLess: !prevState.lineClamp ? "Voir Plus" : "Voir Moins",
    }));
  };

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);
  const ImageGridItem = () => {
    return (
      <div className="relative">
        <img
          onLoad={() => {
            setState((prevState) => ({ ...prevState, loaded: true }));
          }}
          src={images[currentIndex]}
          loading="lazy"
          alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
            images?.length
          }`}
          style={{
            width: "100%",
            maxHeight: "80vh",
            minWidth: "0",
            objectFit: "cover",
          }}
          role="img"
          aria-label={`Image ${currentIndex + 1} de ${
            images?.length
          } du produit ${state?.product?.name}`}
          onContextMenu={(e) => e.preventDefault()}
        />
        <button
          onClick={toggleFullscreen}
          className="absolute bottom-2 right-2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 transition-all"
          aria-label="Afficher en plein écran"
          title="Afficher en plein écran (Cliquer sur l'image)"
        >
          <Fullscreen />
        </button>
      </div>
    );
  };
  const FullscreenModal = () => {
    if (!isFullscreen) return null;
    return (
      <div
        className="fixed inset-0 z-[9999] bg-black bg-opacity-95 flex items-center justify-center"
        onClick={toggleFullscreen}
        role="dialog"
        aria-modal="true"
        aria-label="Visualisation en plein écran"
      >
        <div className="relative w-full h-full flex items-center justify-center">
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 z-10 transition-all"
            aria-label="Fermer le plein écran (Échap)"
            title="Fermer (Échap)"
          >
            <Close fontSize="large" onClick={toggleFullscreen} />
          </button>
          {images?.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronLeft();
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image précédente"
                title="Image précédente (Flèche gauche)"
              >
                <ChevronLeft fontSize="large" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronRight();
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image suivante"
                title="Image suivante (Flèche droite)"
              >
                <ChevronRight fontSize="large" />
              </button>
            </>
          )}
          <img
            src={images[currentIndex]}
            alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
              images?.length
            }`}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
          />
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-75 px-4 py-2 rounded-full">
            <span className="font-semibold">
              {currentIndex + 1} / {images?.length}
            </span>
          </div>
          {images?.length > 1 && (
            <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex gap-1 overflow-x-auto min-w-[70vw] max-w-[90vw] scrollbar-hide">
              {images.map((img, i) => (
                <button
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(i);
                  }}
                  className={`flex-shrink-0 border-2 rounded transition-all ${
                    currentIndex === i
                      ? "border-white ring-2 ring-white"
                      : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={img}
                    alt={`Miniature ${i + 1}`}
                    className="w-16 h-16 object-cover rounded"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <FullscreenModal />
      <Modal
        modalIsOpen={upSalesModalIsOpen}
        className="w-4/5"
        dismissModal={() => dispatch(dismissUpSalesModal())}
        handleModal={() => dispatch(toggleUpSalesModal())}
        content={<UpSell products={products?.productsByIds?.page?.edges} />}
      />
      <Modal
        modalIsOpen={isValidationModalOpen}
        className="w-4/5 md:w-3/12"
        dismissModal={() => dispatch(dismissValidationModal())}
        content={
          <Validation
            pixelId="2318743751858547"
            handleDismiss={() => dispatch(dismissValidationModal())}
            item={{ ...state.product, quantity: state.quantity }}
          />
        }
      />
      {/* The Grid */}
      <div
        className="mx-auto grid min-h-screen"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "5em auto",
        }}
      >
        {/* Header */}
        {/* Header Hack */}
        <div className="header"></div>
        <div className="fixed top-0 left-0 right-0 z-50 bg-white w-full">
          <Banner className="bg-djeliba" />
          <Header />
        </div>
        {/* Content */}
        <div
          style={{
            gridColumn: "1 / -1",
          }}
        >
          <div className="flex flex-col my-5 md:flex-row justify-around items-start">
            <div className="w-full md:w-1/3 border relative">
              <div
                ref={slideRef}
                className="w-full select-none relative"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                role="region"
                aria-label="Carousel d'images du produit"
                aria-live="polite"
              >
                <div className="w-full flex-row flex justify-evenly items-center">
                  <figure className="md:h-full grow md:m-2.5">
                    {ImageGridItem()}
                  </figure>
                </div>
                {images?.length > 1 && (
                  <>
                    <div
                      className="absolute md:my-0 my-4 flex w-full md:flex-col md:w-1/6 md:h-full md:overflow-y-auto overflow-scroll scrollbar-hide md:-left-16 md:-top-1 md:px-3 justify-start items-center bg-transparent"
                      role="tablist"
                      aria-label="Miniatures des images"
                    >
                      {images.map((item, i) => (
                        <button
                          key={i}
                          className={`border rounded md:my-1 hover:border-2 md:w-full min-w-14 mx-1 transition-all ${
                            currentIndex === i
                              ? "border-djeliba border-2 ring-2 ring-djeliba"
                              : "border-djeliba"
                          }`}
                          onClick={() => setCurrentIndex(i)}
                          onMouseEnter={() => setCurrentIndex(i)}
                          role="tab"
                          aria-selected={currentIndex === i}
                          aria-label={`Afficher image ${i + 1}`}
                          title={`Image ${i + 1}`}
                        >
                          <img
                            src={images[i]}
                            alt={`Miniature ${i + 1}`}
                            loading="lazy"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              minWidth: "0",
                              objectFit: "cover",
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="w-full px-1 flex justify-between items-center">
                <div className="flex max-w-min">
                  <a
                    className="text-green-500 top-0 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`tel:${221773808340}`}
                  >
                    <CallSharp
                      className="border rounded-md p-1 text-blue-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                  <a
                    className="text-green-500 top-11 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://api.whatsapp.com/send?phone=${221773808340}&text=${encodeURIComponent(
                      "Je souhaite commander l'article : " +
                        state?.product?.name +
                        "\n\nLien : " +
                        state?.product?.uri
                    )}`}
                  >
                    <WhatsApp
                      className="border rounded-md text-green-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                </div>
                {images?.length > 1 && (
                  <div
                    className="flex w-full h-5 justify-center items-center"
                    role="group"
                    aria-label="Indicateurs de progression du carousel"
                  >
                    {images?.map((item, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentIndex(i)}
                        className={
                          currentIndex === i
                            ? "bg-black h-1.5 w-1.5 rounded-full ml-1 cursor-pointer hover:scale-150 transition-transform"
                            : "bg-slate-400 h-1 w-1.5 rounded-sm ml-1 cursor-pointer hover:bg-slate-600 transition-colors"
                        }
                        aria-label={`Aller à l'image ${i + 1}`}
                        aria-current={currentIndex === i ? "true" : "false"}
                        title={`Image ${i + 1}`}
                      ></button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-14 md:mt-0 md:w-1/2 h-full md:border hover:border-0">
              <div className="mx-2 my-3">
                <LazyMultilingualAudioPlayer
                  productId={state?.product?._id}
                  tracks={{
                    wo: audioTrackWo,
                  }}
                  languageLabels={{
                    wo: "Wolof",
                    pl: "Pulaar",
                    fr: "Français",
                  }}
                />
              </div>
              <div className="flex justify-around md:justify-between items-center mb-2">
                <div id="product-name-container">
                  <div className="m-2">
                    <span className="font-bold text-lg md:text-3xl">
                      {state?.product?.name}
                    </span>
                  </div>
                  <div className="m-2">
                    <span className="font-bold text-yellow-500 md:text-xl">
                      Livraison gratuite
                    </span>
                  </div>
                  <div className="m-2 my-3">
                    <div
                      className={
                        state.quantity === 1
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(1)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Disaar/2.png?sp=r&st=2025-07-08T14:15:57Z&se=2029-07-08T22:15:57Z&sv=2024-11-04&sr=b&sig=XWL%2FO%2BIBnZCYrE3fmzpq4U80r3phlnS1ha%2B0Mb8u1TI%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥
                          <span>1</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice - state.product.price
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 2
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(2)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Disaar/2.png?sp=r&st=2025-07-08T14:15:57Z&se=2029-07-08T22:15:57Z&sv=2024-11-04&sr=b&sig=XWL%2FO%2BIBnZCYrE3fmzpq4U80r3phlnS1ha%2B0Mb8u1TI%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥
                          <span>2</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price_for_two)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 2}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 2 -
                                state.product.price_for_two
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 3
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(3)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Disaar/2.png?sp=r&st=2025-07-08T14:15:57Z&se=2029-07-08T22:15:57Z&sv=2024-11-04&sr=b&sig=XWL%2FO%2BIBnZCYrE3fmzpq4U80r3phlnS1ha%2B0Mb8u1TI%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥🔥
                          <span>3</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(
                              state?.product?.price_for_three
                            )}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 3}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 3 -
                                state.product.price_for_three
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-col justify-evenly items-center">
                  <div className="flex justify-center items-center">
                    <span
                      onClick={handleDecreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-black bg-djeliba text-xl"
                    >
                      -
                    </span>
                    <span className="font-bold rounded-sm px-1 mx-1 bg-black text-white text-lg">
                      {state.quantity}
                    </span>
                    <span
                      onClick={handleIncreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-green-500 bg-djeliba text-xl"
                    >
                      +
                    </span>
                  </div>
                  <div className="px-2">
                    <Button
                      title="Commander"
                      isWaiting={false}
                      handleOnClick={(e) => handleSubmit(e)}
                      disabled={false}
                      className="hover:shadow-2xl cursor-pointer hover:transition-all ease-linear duration-300"
                    />
                  </div>
                </div>
              </div>
              <div className="mx-2">
                {state.lineClamp ? (
                  <p
                    className="border-none w-full outline-none text-sm px-2 py-1 rounded-md ml-1"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                    }}
                    onClick={toggleLineClamp}
                  >
                    DISAAR SÉRUM – Stimule la repousse, freine la calvitie. Le
                    sérum Disaar est un soin capillaire enrichi en extraits de
                    plantes naturelles spécialement conçu pour activer la
                    croissance des cheveux, ralentir la chute et lutter contre
                    la calvitie. Il nourrit intensément le cuir chevelu,
                    renforce les racines et aide à restaurer les zones
                    clairsemées. Grâce à sa formule légère et non grasse, il est
                    aussi très efficace pour favoriser la pousse de la barbe,
                    notamment chez les hommes ayant des zones irrégulières.
                  </p>
                ) : (
                  <div className="flex-row" onClick={toggleLineClamp}>
                    <p className="">
                      Le sérum Disaar est un soin capillaire enrichi en extraits
                      de plantes naturelles spécialement conçu pour activer la
                      croissance des cheveux, ralentir la chute et lutter contre
                      la calvitie. Il nourrit intensément le cuir chevelu,
                      renforce les racines et aide à restaurer les zones
                      clairsemées. Grâce à sa formule légère et non grasse, il
                      est aussi très efficace pour favoriser la pousse de la
                      barbe, notamment chez les hommes ayant des zones
                      irrégulières.
                    </p>
                    <div className="m-1">
                      <h2 className="text-lg">
                        💡 Les bienfaits de Disaar Sérum :
                      </h2>

                      <ul className="list-disc ml-6">
                        <li>
                          ✅ Stimule la repousse des cheveux et de la barbe
                        </li>
                        <li>
                          ✅ Ralentit la chute liée au stress, aux hormones ou à
                          l’âge
                        </li>
                        <li>
                          ✅ Agit contre l’alopécie et la calvitie masculine ou
                          féminine
                        </li>
                        <li>
                          ✅ Améliore l’épaisseur et la densité des cheveux
                        </li>
                        <li>
                          ✅ À base de plantes naturelles, sans produits
                          chimiques agressifs
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/75.png?sp=r&st=2025-07-08T15:19:31Z&se=2029-07-08T23:19:31Z&sv=2024-11-04&sr=b&sig=%2BpuXw868ESBZUsbUOeQkuyCvMNdh0onTjGlH9VMmq2w%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">📌 Mode d’utilisation :</h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Appliquer quelques gouttes sur les zones concernées
                          (tempes, crâne, barbe)
                        </li>
                        <li>Masser doucement jusqu’à absorption</li>
                        <li>
                          À utiliser matin et soir, sur peau propre et sèche
                        </li>
                        <li>
                          Résultats visibles dès 3 à 6 semaines avec une
                          utilisation régulière
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Disaar/11.png?sp=r&st=2025-07-08T14:21:47Z&se=2029-07-08T22:21:47Z&sv=2024-11-04&sr=b&sig=nwggA3CMQ8iyPn8yUsg%2BC90mSkTBtogDv3UewIZPNyA%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        🌿 Naturel, simple à utiliser, sans danger
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Disaar est un choix sûr et naturel pour toute personne
                          souhaitant ralentir la chute, stimuler la repousse et
                          retrouver une chevelure ou une barbe plus dense, sans
                          passer par des solutions chimiques lourdes ou
                          invasives.
                        </li>
                        <li>
                          DISAAR SÉRUM – Reprends le contrôle de ta repousse.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/69.png?sp=r&st=2025-07-08T14:08:12Z&se=2029-07-08T22:08:12Z&sv=2024-11-04&sr=b&sig=mZI%2Fm9lL6LMr%2BOZ1CtmWRk7GHq9IeKv1qhDk%2BEGfBEQ%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <span
                  className="text-sm font-thin text-gray-400 cursor-pointer"
                  onClick={toggleLineClamp}
                >
                  {state.showMoreOrLess}
                </span>
              </div>

              <div className="flex-col w-full mt-2 md:mt-0 h-full overflow-hidden">
                {/* Integrate the CommentSection component */}
                <CommentSection />
              </div>
            </div>
          </div>
        </div>

        {/* Recommendation */}
        <div
          className="p-0 my-2"
          style={{
            gridColumn: "1 / -1",
          }}
        >
          {/* <>
            <div className="flex justify-start md:justify-center items-center m-2 p-1">
              <span className="font-bold text-xl">
                D'autres produits de{" "}
                <span className="text-yellow-500">{data?.product?.shop?.name}</span>
              </span>
            </div>
            <Slider
              images={data?.productsByShop.page.edges?.map(
                (item) => item?.node?.images[0]?.lg
              )}
            />
          </> */}
        </div>

        {/* Footer */}

        {/* Bouton flottant pour remonter en haut */}
        <FloatingButton targetSelector="#product-name-container" />
      </div>
    </>
  );
}

export default DISAAR;
